import { useGetOne } from "ra-core";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { ClientStageBar } from "../ClientStageBar";
import type { GulaClient } from "../gulaTypes";
import { missionName, type CallMission } from "./callPlan";

/**
 * «Hablado» never leaves a lead in limbo: the setter picks the next step
 * (Recontactar with a date, Cierre de compra, Compra or No compra).
 */
export const NextStepDialog = ({
  mission,
  onClose,
  onChanged,
}: {
  mission: CallMission | null;
  onClose: () => void;
  onChanged: () => void;
}) => {
  const { data: client } = useGetOne<GulaClient>(
    "gula_clients_summary",
    { id: mission?.client_id ?? 0 },
    { enabled: !!mission },
  );
  if (!mission) return null;
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Has hablado con {missionName(mission)}</DialogTitle>
          <DialogDescription>
            Elige qué pasa ahora: así quien le llame después sabe qué hacer.
          </DialogDescription>
        </DialogHeader>
        {client && String(client.id) === String(mission.client_id) ? (
          <ClientStageBar
            client={client}
            onChanged={() => {
              onClose();
              onChanged();
            }}
          />
        ) : (
          <p className="text-sm text-muted-foreground">Cargando…</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
